import React from 'react'
import Image from 'next/image'
import { imageLoader } from '../../context/utils'
import { IMedia } from '../../interfaces/media'

interface IMagazineProps {
  issueLink: string
  issueCover: IMedia
}

const Magazine: React.FC<IMagazineProps> = ({ issueLink, issueCover }) => {
  const handleClick = () => {
    window.open(issueLink, '_blank');
  }

  return (
    <div className='h-full'>
      <div className='relative flex flex-col h-full items-center justify-center'>
        <div
          className='h-magazine-cover md:rotate-6 w-full drop-shadow-2xl relative 2xl:absolute 2xl:-top-[80px] cursor-pointer'
          onClick={handleClick}
        >
          {issueCover && (
            <Image
              tabIndex={0}
              loader={imageLoader}
              alt='BP 18 magazin'
              title='BP 18 magazin'
              src={issueCover.fileUrl}
              layout='fill'
              objectFit='scale-down'
            />
          )}
        </div>
        <p className='font-montserrat font-semibold text-footer-text-2xl 2xl:absolute bottom-20 mt-3 mb-3'>
          BP18 Magazin
        </p>
      </div>
    </div>
  )
}

export default Magazine
